import Vue from 'vue';
import VueHotkey from 'v-hotkey';
import App from './App.vue';
import router from './router';
import store from './store';
import VueGtag from 'vue-gtag';
//import Vuelidate from 'vuelidate';

Vue.config.productionTip = false;

//Vue.use(Vuelidate);
Vue.use(VueHotkey);

// Check if there is a Google Analytics Toggle set true and if so set up Google Analytics with a Tracking code.
if (window.__selector_settings__.trackers.gaCheck === true) {
  Vue.use(VueGtag, {
    includes: [
      { 
        id: 'G-1B0TKSZ0KK',
        params: {
          anonymize_ip: true,
        },
      },
    ],
    config: { id: window.__selector_settings__.trackers.gaTrackingCode, },
    appName: 'Ensign Boligprosjekter',
  });
} else {
  Vue.use(VueGtag, {
    config: { id: 'G-1B0TKSZ0KK', },
    appName: 'Ensign Boligprosjekter',
  });
}

// Find DOM element to inject SPA:
const boligvelgeren = document.getElementById('boligvelgeren');

if (boligvelgeren) {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#boligvelgeren');
}
